"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.values");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'mytempl',
  data: function data() {
    return {
      list: [],
      tempDialog: false,
      tempInfo: {},
      template_id: '',
      appid: ''
    };
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return Object.values(this.$store.state.user.deviceNameObj);
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this = this;
      this.$get('agentapi/system/news_mould').then(function (res) {
        _this.list = res;
      });
    },
    /**
     * 是否隐藏洗衣机分享设置
     */
    tableStyle: function tableStyle(row) {
      if (row.row.mould_type < 20 && this.deviceNameObj.indexOf(row.row.mould_type) == -1) {
        return {
          'display': 'none'
        };
      }
    },
    /**
     * 修改模板ID
     */
    editID: function editID() {
      var _this2 = this;
      var params = {},
        tempInfo = this.tempInfo;
      params["mould_template_id_".concat(tempInfo.mould_id)] = this.template_id;
      params.appid = this.appid;
      // 【操作埋点】2026-05-25 pc_setting_update_1 消息模板 ID/appid
      this.$post('agentapi/system/news_mould', params).then(function (res) {
        _this2.$settingReport.reportSettingUpdate('news_mould', "\u6D88\u606F\u6A21\u677F\u300C".concat(tempInfo.mould_name || '', "\u300D"), {
          template_id: tempInfo.template_id,
          appid: tempInfo.appid
        }, {
          template_id: _this2.template_id,
          appid: _this2.appid
        });
        _this2.tempDialog = false;
        _this2.tempInfo.template_id = _this2.template_id;
        _this2.tempInfo.appid = _this2.appid;
        _this2.$message({
          message: '设置成功',
          type: 'success'
        });
      });
    }
  }
};